<template>
	<div>
		<div
			class="modal fade"
			id="importClientPopup"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px;top:80px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Upload Accounts</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "getList">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px;margin-left:40px;">
						<div class = "form-group row">
							<div v-if = "isFileUploading" class="spinner-border" ></div>
							<div v-else>
								<div class = "col-md-12 row" v-if = "!isDataSyncing">
									<!-- <div class = "col-md-3">
									    <a style = "display:flex;align-items:center;" @click = "downloadFile" href ="javascript:void(0)">Download Sample Accounts</a>
									</div> -->
									<p style = "margin-bottom:30px;margin-left: 15px;border: 1px black solid;padding: 10px;width: 100%;">Please provide a first name, last name, and email in order for contacts to be updated.</p>

									<div class = "col-md-6" >
										<input
											class="choose"
											type="file"
											placeholder="Import Data From csv"
											multiple="false"
											accept=".csv"
											@change="uploadFile"
										>
									</div>
									<div class = "col-md-1"></div>
									<!-- <div class = "col-md-5" style = "padding:0px;margin:0px" >
										<p v-if = "isDataSyncing" style = "color:red">.....We are processing your request this may take some time...we will notify you when done</p>
									</div> -->

									<!-- <div class = "col-md-4 pt-5" v-if="!isDataSyncing">
										<p style = "color:green">Data has been updated SuccessFully</p>
									</div> -->


								</div>
								<div v-if = "isDataSyncing" style = "margin:15px"><p>We are Processing your request this may take some time... We will notify you via email once completed.</p></div>
							</div>
						</div>
                        <!-- <div>Feature under progress ...</div> -->
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import XLSX from "xlsx";

	export default {
		name: "ImportClientData",
		components: {
		},
		mounted() {
			//this.openCampaignGroup();
		},
		data() {
			return {
				isFileUploading:false,
				fileUploadedName:"",
				isDataSyncing:false,
				isDataUploded:'',
				notaddedAsin: []
			};
		},
		watch: {},
		methods: {
			getList(){
				
				this.fileUploadedName = "";
				this.isDataSyncing = false;
				this.isFileUploading = false;
				this.isDataUploded = '';
				this.$emit("closeImportClientPopUp")
			},

			uploadFile(evt){
				let file = evt.target.file || evt.target.files[0];
				let vm = this;
			    this.isFileUploading = true;
				this.$store.dispatch("accounts/getPresighnedURL").then((res) => {
					let data = {
						url : res.uploadUrl,
						data: file
					}
					vm.$store.dispatch("accounts/uploadFile", data).then(response => {
						vm.isFileUploading = false;
						vm.fileUploadedName = file.name
						let payload = {
							uploadUrl: res.uploadUrl,
							downloadUrl: res.downloadUrl,
							name: file.name
						}
						vm.isDataSyncing = true;
						vm.$store.dispatch("accounts/updateFileData", payload).then((data) => {
							//vm.isDataSyncing = false;
						})
					})
				})

		},
		// createFile(){
		//
		// 	// var element = document.createElement('a');
		// 	// element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.notaddedAsin));
		// 	// element.setAttribute('download', 'test.txt');
		// 	// element.target = '_b'
		// 	// element.style.display = 'none';
		// 	// document.body.appendChild(element);
		// 	//
		// 	// element.click();
		//
		// 	let vm = this;
		//
		// 	if(this.notaddedAsin.length){
		// 		let data = this.notaddedAsin.map((res) => {
		// 			return {asin:res}
		// 		})
		//
		// 		const wb = XLSX.utils.book_new();
		// 		var workbook = XLSX.utils.json_to_sheet(data);
		//
		// 		XLSX.utils.book_append_sheet(
		// 			wb,
		// 			workbook,
		// 			"asins.csv"
		// 		);
		//
		//
		// 		let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
		// 		let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
		//
		// 		if(safariAgent && !chromeAgent){
		// 			var wbout = XLSX.write(wb, {bookType:'csv',  type: 'binary'});
		// 			var blob = new Blob([vm.s2ab(wbout)], { type: 'application/octet-stream"' });
		// 			var link = document.createElement('a');
		// 			link.href = URL.createObjectURL(blob);
		// 			link.download = "asins-file.csv";
		// 			link.target = "_blank";
		// 			link.click();
		// 		}
		// 		else{
		//
		// 			var wbout = XLSX.write(wb, {bookType:'csv',  type: 'binary'});
		// 			var blob = new Blob([vm.s2ab(wbout)], { type: 'text/csv;charset=utf-8;'  });
		// 			let url = window.URL.createObjectURL(blob);
		// 			let w =  window.open(url, '_blank');
		// 			w.focus()
		// 		}
		//
		// 	}
		//
		//
		// 		//w.document.execCommand('SaveAs', true, 'asin.txt')
		// },
		// s2ab(s) {
		// 	var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
		// 	var view = new Uint8Array(buf);  //create uint8array as viewer
		// 	for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
		// 	return buf;
		// },
		// downloadFile(){
		//
		// 	let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
		// 	let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
		// 	if(safariAgent && !chromeAgent){
		// 		var link = document.createElement('a');
		// 		link.href = ('/sampleAccounts.csv');
		// 		link.download = "sampleAccounts.csv";
		// 		link.target = "_blank";
		// 		link.click();
		// 	}
		// 	else{
		// 		var w = window.open('/sampleAccounts.csv', '_blank');
		// 		//w.document.execCommand('SaveAs', true, 'sampleProducts.csv')
		// 		w.focus();
		// 	}


		//}
	}
}
</script>
<style lang="scss">
</style>
